export const API_URL = process.env.REACT_APP_API_URL ?? "";
export const SITE_URL = process.env.REACT_APP_SITE_URL ?? "";
export const SITE_NAME = process.env.REACT_APP_SITE_NAME ?? "";
export const SITE_ID = process.env.REACT_APP_SITE_ID ?? 0;
export const SUBSCRIBER_ID = process.env.REACT_APP_SUBSCRIBER_ID ?? 0;
